import { useIsMobileHook } from '@teliaee/telia-common-components';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { CardContent, Collapse, CollapseProvider, CollapseToggle, CollapseTrigger, GridColumn, Heading, Separator, Text } from 'telia-front-react';
import SsoStore from '../stores/SsoStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import MeluAdditionalOffersCard from './MeluAdditionalOfferCard';
import MeluCalculationCollapseContent from './MeluCalculationCollapseContent';
import { Prices } from './MeluCalculator';
import MeluNetflixOfferCard from './MeluNetflixOfferCard';
import MeluSummaryTable from './MeluSummaryTable';

interface Props {
  internetDeviceCount: number;
  callsDeviceCount: number;
  internetDataAmount: number;
  roamingDataAmount: string;
  prices?: Prices;
  showNetflixOfferCard?: boolean;
  ssoStore?: SsoStore;
}

const MeluSummaryCard = (props: Props): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const { isMobileOrTablet } = useIsMobileHook();

  return (
    <GridColumn width={['lg-6']}>
      <CardContent padding={!isMobileOrTablet && { left: 'medium', right: 'none' }}>
        <Text>
          <MeluAdditionalOffersCard />
          <Separator spacing="xsmall" color="invisible" />
          {props.showNetflixOfferCard && <MeluNetflixOfferCard />}
          <Heading element="h2" className="h4 text-right">
            <strong>{translate('meluCalculator.summaryCard.title')}</strong>
          </Heading>
          <MeluSummaryTable
            internetDeviceCount={props.internetDeviceCount}
            callsDeviceCount={props.callsDeviceCount}
            internetDataAmount={props.internetDataAmount}
            prices={props.prices}
          />
          {!!props.internetDeviceCount && (
            <div className="text-right">
              <CollapseProvider defaultIsVisible={true} id="calculation-collapse">
                <CollapseTrigger>
                  <CollapseToggle text={translate('meluCalculator.monthlyPayment.calculation')} link={true} iconRight="#arrow-down" className="btn--employee" />
                </CollapseTrigger>
                <Collapse className="text-left" noContainer={true}>
                  <Separator color="invisible" spacing="small" />
                  <MeluCalculationCollapseContent
                    internetDeviceCount={props.internetDeviceCount}
                    callsDeviceCount={props.callsDeviceCount}
                    internetDataAmount={props.internetDataAmount}
                    roamingDataAmount={props.roamingDataAmount}
                    prices={props.prices}
                  />
                </Collapse>
              </CollapseProvider>
            </div>
          )}
        </Text>
      </CardContent>
    </GridColumn>
  );
};

export default inject('ssoStore')(observer(MeluSummaryCard));
